import PropTypes from 'prop-types';
import React from 'react';

const withNotifications = (WrappedComponent) => {
  const component = (props, context) => (
    <WrappedComponent
      {...props}
      addNotification={context.addNotification}
      removeNotification={context.removeNotification}
      clearNotifications={context.clearNotifications}
    />
  );
  component.contextTypes = {
    addNotification: PropTypes.func.isRequired,
    removeNotification: PropTypes.func.isRequired,
    clearNotifications: PropTypes.func.isRequired,
  };

  return component;
};

export default withNotifications;
